/** Match web content to a company name / website — avoid wrong Wikipedia hits. */

const STOP_WORDS = new Set([
  'pte',
  'ltd',
  'limited',
  'company',
  'enterprise',
  'private',
  'the',
  'and',
  'group',
  'holding',
  'inc',
  'llc',
  'co',
]);

export function companyNameTokens(companyName: string): string[] {
  return companyName
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .split(/\s+/)
    .filter((t) => t.length > 2 && !STOP_WORDS.has(t));
}

export function websiteHost(website?: string | null): string | null {
  if (!website?.trim()) return null;
  try {
    const u = new URL(website.trim().startsWith('http') ? website.trim() : `https://${website.trim()}`);
    return u.hostname.replace(/^www\./, '').toLowerCase();
  } catch {
    return null;
  }
}

export function textMatchesCompany(
  haystack: string,
  companyName: string,
  website?: string | null,
): boolean {
  const tokens = companyNameTokens(companyName);
  if (tokens.length === 0) return false;

  const hay = haystack.toLowerCase();
  const host = websiteHost(website);
  if (host && hay.includes(host)) return true;
  if (host) {
    const brand = host.split('.')[0];
    if (brand.length > 2 && hay.includes(brand)) return true;
  }

  const matched = tokens.filter((t) => hay.includes(t)).length;
  const required = tokens.length <= 2 ? tokens.length : Math.max(2, Math.ceil(tokens.length * 0.5));
  return matched >= required;
}
